module.exports = __webpack_public_path__ + "img/302.6d028a0b.jpg";